import React, { useContext, useEffect, useState } from 'react'

const myAccountURL = process.env.REACT_APP_MYACCOUNT;

import Link from '../Atoms/Link';
import Logo from '../Atoms/Logo';
import Title from '../Atoms/Title';
import Image from '../Atoms/Image';
import Hamburguer from '../Atoms/Hamburguer';
import Cookies from 'js-cookie';
import Logout from '../../../Handlers/_Logout';
import getProductoPremium from '../../../Models/ProductoPremium';
import { CookieContext } from '../../../Contexts/CookieContext';
import PortalLoading from "../../../Helpers/PortalLoading";
import profileImg from '../../../Statics/Imgs/profile.png';

import '../../../Statics/Scss/Components/Header.scss';
import ModalByCookie from '../../Features/ModalByCookie';

const Header = ({ setMenuVisibility }) => {
  let usuarioId = Cookies.get("usuarioemail");
  let homeLN = process.env.REACT_APP_HOME
  const [productoPremium, setProductoPremium] = useState("")
  const [updateCookie, setUpdateCookie] = useContext(CookieContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setUpdateCookie(false)
    setProductoPremium(Cookies.get("ProductoPremiumId"))
  }, [updateCookie])

  let user = {
    "CurrentUser":
    {
      "ProductoPremium": getProductoPremium(productoPremium),
      "Usuario": usuarioId
    }
  }

  const handleLogout = () => {
    setIsLoading(true);
    Logout.Logout(true);
  }

  return (
    <header className="header">

      <div className="lay">

        <div className="left">
          <Logo name="la-nacion" href={homeLN} mod="--color" title="LA NACION" />
          <Logo name="ln" href={homeLN} mod="--xs" title="LA NACION" />
        </div>

        <div className="middle">
          <Title size="--l --sueca --font-bold">Mi Cuenta</Title>
        </div>

        <div className="right 4xs">

          <ModalByCookie/>

          <div>
            <Image href={`${myAccountURL}`} src={profileImg} alt="Nombre usuario" mod="--md" />
            <div>
              <Link mod="--font-bold" href={`${myAccountURL}`} text={user.CurrentUser.Usuario} />
              {/* <span className="com-text --fivexs">Estado de usuario</span> */}
              {user.CurrentUser.ProductoPremium ?
                <span className="chapita-conSuscrip com-text --fivexs">Suscriptor digital</span>
                :
                <a href="https://suscripciones.lanacion.com.ar/suscribirme/" className="chapita-sinSuscrip com-text --fivexs">Sin suscripción digital</a>
              }
            </div>
          </div>

          <PortalLoading isLoading={isLoading}></PortalLoading>
          <ul className="com-list --inline">
            <li><Link tabindex="0" onClick={() => { handleLogout() }} text="Cerrar sesión" /></li>
            <li><Link href="https://www.contacto.lanacion.com.ar/ayuda" target="_blank" text="Ayuda" /></li>
          </ul>

          <Hamburguer onClick={() => setMenuVisibility()} />

        </div>

      </div>

    </header>
  )
}



export default Header;


